import { config } from '../Constants';
import { post } from './service';
import { userLogin as localLogin } from './local-service';

const APIURL_AUTH = config.url.API_URL + '/Assessment/Login';

const userLoginFunc = (params, successFunc, errorFunc, finallFunc) => post(APIURL_AUTH, params, successFunc, errorFunc, finallFunc, true);

export const userLogin = config.isLocal ? localLogin : userLoginFunc;